import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { CTAButton } from './CTAButton';
import { ChevronDownIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿En qué formato recibo el sistema?',
  a: '8 archivos PDF de alta calidad en tu email después de la compra. Podés leerlos en cualquier dispositivo o imprimirlos.'
}, {
  q: '¿Necesito experiencia previa?',
  a: 'No. Funciona tanto para quien empieza desde cero como para quien lleva años en el nicho sin resultados consistentes.'
}, {
  q: '¿Cuánto tiempo necesito por día?',
  a: '35 minutos distribuidos en 5 momentos del día. El Bono 3 incluye un protocolo de emergencia de 10 minutos para los días difíciles.'
}, {
  q: '¿Cuándo veo resultados?',
  a: 'Muchos reportan sincronías desde el día 2 o 3. La transformación de identidad ocurre en los 21 días del protocolo completo.'
}, {
  q: '¿Puedo imprimir los documentos?',
  a: 'Absolutamente. Lo recomendamos especialmente para el Bono 3 con los checklists diarios.'
}, {
  q: '¿Es lo mismo que Silva o los libros de Neville?',
  a: 'No. El Protocolo 24H toma los mejores elementos de cada método y los integra en un flujo de 24 horas que ninguno de esos sistemas por separado ofrece.'
}];
function FAQItem({
  faq,
  isOpen,
  onToggle
}: {
  faq: (typeof faqs)[0];
  isOpen: boolean;
  onToggle: () => void;
}) {
  return <div className="border-b border-brand-gold/10" data-id="element-41">
      <button onClick={onToggle} className="w-full flex items-center justify-between py-5 text-left gap-4" aria-expanded={isOpen} data-id="element-42">
        <span className={`font-body font-semibold text-base md:text-lg transition-colors ${isOpen ? 'text-brand-gold' : 'text-brand-ivory'}`} data-id="element-43">
          {faq.q}
        </span>
        <motion.span animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.25
      }} className="shrink-0" data-id="element-44">
          <ChevronDownIcon className="w-5 h-5 text-brand-gold" data-id="element-45" />
        </motion.span>
      </button>
      <AnimatePresence initial={false} data-id="element-46">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-47">
            <p className="text-brand-muted font-body text-base leading-relaxed pb-5" data-id="element-48">
              {faq.a}
            </p>
          </motion.div>}
      </AnimatePresence>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <SectionWrapper bgColor="bg-brand-black" data-id="element-49">
      <h2 className="font-heading text-2xl md:text-3xl text-brand-ivory text-center font-semibold" data-id="element-50">
        Preguntas Frecuentes
      </h2>

      <div className="mt-10 max-w-2xl mx-auto" data-id="element-51">
        {faqs.map((faq, i) => <FAQItem key={i} faq={faq} isOpen={openIndex === i} onToggle={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-52" />)}
      </div>

      <div className="mt-14" data-id="element-53">
        <CTAButton text="→ EMPEZAR MI PROTOCOLO 24H AHORA — $19.990" subtext="Acceso inmediato garantizado" data-id="element-54" />
      </div>
    </SectionWrapper>;
}